import React, { useEffect, useState } from "react";

export default function Countdown({ targetDate }) {
  const [timeLeft, setTimeLeft] = useState({});

  useEffect(() => {
    const interval = setInterval(() => {
      // Get current time in Mauritius timezone (UTC+4)
      const now = new Date();
      const mauritiusNow = new Date(now.toLocaleString('en-US', { timeZone: 'Indian/Mauritius' }));
      
      // Parse target date (which includes +04:00 offset for Mauritius)
      const target = new Date(targetDate);
      
      const difference = target - mauritiusNow;
      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60),
        });
      } else {
        clearInterval(interval);
        setTimeLeft({});
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [targetDate]);

  if (!timeLeft.days && !timeLeft.hours && !timeLeft.minutes && !timeLeft.seconds) {
    return <p className="text-xl mt-4"></p>;
  }

  return (
    <div className="flex justify-center space-x-6 mt-6 text-2xl font-bold text-amber-700 bg-white/70 px-6 py-3 rounded-xl shadow-lg backdrop-blur">
      <div>{timeLeft.days}d</div>
      <div>{timeLeft.hours}h</div>
      <div>{timeLeft.minutes}m</div>
      <div>{timeLeft.seconds}s</div>
    </div>
  );
}
